import * as types from './actionTypes';

export const get = (separation_type, pageNumber=null) =>{
  return{
    type: types.API_CALL_OVERALL_COST_REQUEST,
    separation_type: separation_type,
    pageNumber
  }
};

export const getSuccess = data => {
  return {
    type: types.PUT_OVERALL_COST,
    payLoad: {data, loading: false}
  };
};
export const getFailure = () => {
  return {
    type: types.PUT_OVERALL_COST,
    payLoad: {loading: false, error:true}
  };
};
